import { removeHash } from '../lib/crypto';

export function defaultHeaders(headers: Headers, token?: string) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set('Authorization', `Bearer ${token}`);
  }

  defaultHeader.set('ngrok-skip-browser-warning', 'true');

  const productType = localStorage.getItem('product-type');
  const productId = productType ? removeHash(JSON.parse(productType)) : 21;

  defaultHeader.set('productId', productId?.toString() as string);

  return defaultHeader;
}
